import { render, staticRenderFns } from "./VaffMediaField.vue?vue&type=template&id=0a7e682e&scoped=true&"
import script from "./VaffMediaField.vue?vue&type=script&lang=js&"
export * from "./VaffMediaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e682e",
  null
  
)

export default component.exports